import { useEffect } from 'react';

// Simple SEO helper without extra dependencies
// Props: title, description, path, image
const BASE_URL = typeof window !== 'undefined' ? window.location.origin : 'https://e-omiservices.fr';

function setMeta(property, content, attr = 'name') {
  if (!content) return;
  // Correct attribute selector: meta[name="..."] or meta[property="..."]
  let el = document.querySelector(`meta[${attr}="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

const SEO = ({ title, description, path = '/', image = '/images/logo.svg' }) => {
  useEffect(() => {
    const url = `${BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
    const fullImage = image.startsWith('http') ? image : `${BASE_URL}${image}`;

    // Title
    if (title) document.title = title;

    // Meta description
    setMeta('description', description);

    // Canonical
    setLink('canonical', url);

    // Open Graph
    setMeta('og:type', 'website', 'property');
    setMeta('og:title', title, 'property');
    setMeta('og:description', description, 'property');
    setMeta('og:url', url, 'property');
    setMeta('og:image', fullImage, 'property');

    // Twitter
    setMeta('twitter:card', 'summary_large_image', 'property');
    setMeta('twitter:title', title, 'property');
    setMeta('twitter:description', description, 'property');
    setMeta('twitter:image', fullImage, 'property');
  }, [title, description, path, image]);

  return null;
};

export default SEO;
